// extracted by mini-css-extract-plugin
export var container = "_f6-0";
export var icon = "_f6-1";
export var text = "_f6-2";